import { Result } from '../../api/api';
import { StatusField } from '../Common/StatusLabel';

interface IProps {
  result: Result<string>;
  kind: 'upgrade' | 'desired';
}

export const DeviceCommandStatus = ({ result, kind }: IProps) => {
  if (result.status === 'OK') {
    const responseMessage =
      kind === 'upgrade' &&
      typeof result.data === 'string' &&
      result.data !== 'OK'
        ? result.data
        : kind === 'desired'
          ? 'Desired firmware saved. Waiting for device outcome.'
          : 'Upgrade request submitted. Waiting for device outcome.';
    const noCommandSent =
      kind === 'upgrade' &&
      responseMessage.startsWith('No firmware command sent.');

    return (
      <div
        className={`font-thin text-xs ${
          noCommandSent ? 'text-amber-700' : ''
        }`}
        role={noCommandSent ? 'alert' : 'status'}
        aria-live="polite"
      >
        {responseMessage}
      </div>
    );
  }

  if (result.status === 'Loading') {
    return (
      <div
        className="font-thin text-xs"
        role="status"
        aria-live="polite"
      >
        Submitting request...
      </div>
    );
  }

  return <StatusField result={result} />;
};
